import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ClientSupportInfo from './ClientSupportInfo';
import { useAuth } from '../../contexts/AuthContext';
import useFetchClientDynamicConfig from '../../api/FetchClientDynamicConfig';

const ClientSupportInfoWrapper = ({ darkMode, clientConfig }) => {
    const { user } = useAuth();
    const userRole = user?.roles;
    const [supportInfo, setSupportInfo] = useState(null);
    const { FetchClientDynamicConfig, response: dynamicConfig } = useFetchClientDynamicConfig();

    useEffect(() => {
        // Only fetch for student role
        if (userRole === 'student' && clientConfig?.client_id) {
            FetchClientDynamicConfig(clientConfig.client_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRole, clientConfig?.client_id]);

    useEffect(() => {
        if (dynamicConfig?.data?.dynamic_config?.client_support_info) {
            setSupportInfo(dynamicConfig.data.dynamic_config.client_support_info);
        }
    }, [dynamicConfig]);

    // Only render for student role
    if (userRole !== 'student') {
        return null;
    }

    return <ClientSupportInfo supportInfo={supportInfo} darkMode={darkMode} />;
};

ClientSupportInfoWrapper.propTypes = {
    darkMode: PropTypes.bool,
    clientConfig: PropTypes.shape({
        client_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
};

ClientSupportInfoWrapper.defaultProps = {
    darkMode: false,
    clientConfig: null,
};

export default ClientSupportInfoWrapper;
